import { AUTHED_INFOR_LOCAL_STORAGE, JWT_TOKEN_LOCAL_STORAGE, REFRESH_TOKEN_LOCAL_STORAGE } from '@const/auth'
import { set } from '@services/local-storage-service'

/**
 * remove all the auth information from local storage
 */
export const removeAuth = () => {
  set(AUTHED_INFOR_LOCAL_STORAGE, '')
  set(JWT_TOKEN_LOCAL_STORAGE, '')
  set(REFRESH_TOKEN_LOCAL_STORAGE, '')
}
